<template>
  <div class="container content">
    <!--div class="headline" v-if="enrolled_educations.length > 0">
      <h1>{{ $t('message.education.list.enrolled.header') }}</h1>
    </div>
    <div class="tile is-ancestor koulutukset-boxes" v-if="enrolled_educations.length > 0">
      <div v-for="education in enrolled_educations" :key="education.id" class="tile is-parent is-4">
       <article class="tile is-child box">
          <p class="title">{{ $t('message.education.list.item.header') }}</p>
          <img src="img/adinum_logo.png">
          <h2 class="koulutuksen-otsikko">{{education.name}}</h2>
          <p class="koulutuksen-ajankohta">{{formatDate(education.course_start)}} - {{formatDate(education.course_end)}}</p>
          <p class="koulutuksen-teksti">
            {{ education.description }}
          </p>
          <br />
          <b-button
            :label="$t('message.education.list.read-more-and-enroll')"
            type="is-primary"
            @click="() => openEducation(education.id)" />
          <span class="koulutuksen-hinta">{{education.price}}<span>€</span></span>
       </article>
      </div>
    </div-->
    <div class="headline">
      <h1>{{ $t('message.education.list.header') }}</h1>
    </div>
    <div v-for="educationBlock in educationsInBlocks" :key="educationBlock.id" class="tile is-ancestor koulutukset-boxes">
      <div v-for="education in educationBlock.els" :key="education.id" class="tile is-parent is-4">
       <article class="tile is-child box">
          
          <p class="title title-presentation" v-if="education.type == 'esittely'">
            {{ $t('message.education.list.item.presentation') }}
          </p>
          <p class="title" v-else-if="!enrollments.map(enrollment => enrollment.course_id).includes(education.id)">
            {{ $t('message.education.list.item.header') }}
          </p>
          <p class="title" v-else-if="enrollments.map(enrollment => enrollment.course_id).includes(education.id)">
            {{ $t('message.education.list.item.header-enrolled') }}
          </p>
          
          <img src="img/adinum_logo.png" v-if="education.img_url === null">
          <img :src="education.img_url" v-if="education.img_url !== null">
          <h2 class="koulutuksen-otsikko">{{education.name}}</h2>
          <p v-if="education.type == 'koulutus'" class="koulutuksen-ajankohta">{{formatDate(education.course_start)}} - {{formatDate(education.course_end)}}</p>
          <p class="koulutuksen-teksti">
            {{ education.description }}
          </p>
          <span v-if="user && user.type == 'education_partner'">
            <b-button
            :label="$t('message.education.list.publish')"
            type="is-primary"
            v-if="education.status == 'draft'"
            v-on:click="() => { changeEducationState(education, 'public') }" />

            <b-button
              :label="$t('message.education.list.unpublish')"
              type="is-primary"
              v-if="education.status == 'public'"
              v-on:click="() => { changeEducationState(education, 'draft') }" />
          </span>
          <br />

          <b-button v-if="user && user.type != 'education_partner' && enrollments.map(enrollment => enrollment.course_id).includes(education.id)"
            :label="education.type == 'koulutus' ? $t('message.education.list.read-more-and-enroll') : $t('message.education.list.read-more')"
            type="is-primary"
            @click="() => openEducation(education.id)" />

          <b-button v-if="user && user.type != 'education_partner' && !enrollments.map(enrollment => enrollment.course_id).includes(education.id)"
            :label="education.type == 'koulutus' ? $t('message.education.list.read-more-and-enroll') : $t('message.education.list.read-more')"
            type="is-primary"
            @click="() => openEducation(education.id)" />

          <b-button v-if="user && user.type == 'education_partner'"
            :label="$t('message.education.list.edit-education')"
            type="is-primary"
            @click="() => openEducationForEditing(education.id)" />

          <span v-if="education.type == 'koulutus'" class="koulutuksen-hinta">{{education.price}}<span>€</span></span>
       </article>
      </div>
    </div>   
  </div>
</template>


<script>
export default {
    data() {
        return {}
    },
    methods: {
      openEducation(id) {
        this.$router.push('/koulutus/' + id)
      },
      openEducationForEditing(id) {
        this.$router.push('/muokkaa-koulutus/' + id)
      },
      formatDate(_date) {
        return this.$moment(_date, 'YYYY-MM-DD hh:mm:ss').format('DD.MM.YYYY');
      },
      changeEducationState(education, _status) {
        this.$store.dispatch("publishEducation", {id: education.id, status: _status}).then((response) => {
              var status = response.status
              if (status >= 200 && status < 300) {
                  education.status = _status
                  this.toastSuccess(this.$t('message.education.toaster.publishSuccess'));
              } else {
                  this.toastFailure(this.$t('message.education.toaster.publishError'));
              }
          }).catch((error) => {
              this.ERROR(error);
              this.toastFailure(this.$t('message.education.toaster.publishError'));
          });
      }
    },

    computed: {
        educations() {
            if (this.user && this.user.type == "education_partner"){
              return this.$store.getters['getCourses']
            } 
            return this.$store.getters['getCourses2']
        },
        educationsInBlocks() {
            var blocks = []
            var j = 0
            var block = {id: j, els: []}
            
            for (var i = 0; i < this.educations.length; i++) {
              block.els.push(this.educations[i])
              if (block.els.length == 3) {
                blocks.push(block)
                j++
                block = {id: j, els: []}
              }
            }
            if (block.els.length > 0) {
              blocks.push(block)
            }
            //console.log(blocks, this.educations)
            return blocks
        },
        user() {
            return this.$store.getters['getUser']
        }, 
        enrollments() {
          return this.$store.getters['getEnrollments']
        },
        //enrolled_educations() {
        //  var courses = this.$store.getters['getCourses']
        //  var enrolled = courses.filter(course => this.enrollments.map(enrollment => enrollment.course_id).includes(course.id))
        //  return enrolled;
        //},
    },
    mounted() {
        // make sure user is available
        this.$store.dispatch("whoami").then(() => {
            var usr = this.$store.getters['getUser']
            if (usr && usr.type == "education_partner"){
                this.$store.dispatch("fetchEducations");
            } else {
                this.$store.dispatch("fetchEducations2");
            }
            this.$store.dispatch("fetchEnrollments");
        })
    }
}
</script>